<div class="pa-1">
    <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="form">
        <div>
            <mat-form-field class="full-width">
                <mat-label>{{'number_location.content.name'|translate}}</mat-label>

                <input matInput formControlName="name" [placeholder]="'number_location.content.name'|translate"
                    data-ci="name">

                <mat-error *ngIf="form.get('name').invalid && form.get('name').touched"
                    [flexFormControlError]="form.get('name')"></mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="full-width">
                <mat-label>{{'number_location.content.road_number'|translate}}</mat-label>

                <input matInput formControlName="road_number"
                    [placeholder]="'number_location.content.road_number'|translate" data-ci="road_number">
                <button matSuffix mat-icon-button type="button" (click)="removeControlValue('road_number')"
                    [disabled]="!form.get('road_number').value">
                    <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="form.get('road_number').invalid && form.get('road_number').touched"
                    [flexFormControlError]="form.get('road_number')"></mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="full-width">
                <mat-label>{{'number_location.content.road_type'|translate}}</mat-label>

                <input matInput formControlName="road_type"
                    [placeholder]="'number_location.content.road_type'|translate" data-ci="road_type">
                <button matSuffix mat-icon-button type="button" (click)="removeControlValue('road_type')"
                    [disabled]="!form.get('road_type').value">
                    <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="form.get('road_type').invalid && form.get('road_type').touched"
                    [flexFormControlError]="form.get('road_type')"></mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="full-width">
                <mat-label>{{'number_location.content.road_name'|translate}}</mat-label>

                <input matInput formControlName="road_name"
                    [placeholder]="'number_location.content.road_name'|translate" data-ci="road_name">
                <button matSuffix mat-icon-button type="button" (click)="removeControlValue('road_name')"
                    [disabled]="!form.get('road_name').value">
                    <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="form.get('road_name').invalid && form.get('road_name').touched"
                    [flexFormControlError]="form.get('road_name')"></mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="full-width">
                <mat-label>{{'number_location.content.postal_code'|translate}}</mat-label>

                <input matInput formControlName="postal_code"
                    [placeholder]="'number_location.content.postal_code'|translate" data-ci="postal_code">
                <button matSuffix mat-icon-button type="button" (click)="removeControlValue('postal_code')"
                    [disabled]="!form.get('postal_code').value">
                    <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="form.get('postal_code').invalid && form.get('postal_code').touched"
                    [flexFormControlError]="form.get('postal_code')"></mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="full-width">
                <mat-label>{{'number_location.content.city_name'|translate}}</mat-label>

                <input matInput formControlName="city_name"
                    [placeholder]="'number_location.content.city_name'|translate" data-ci="city_name">
                <button matSuffix mat-icon-button type="button" (click)="removeControlValue('city_name')"
                    [disabled]="!form.get('city_name').value">
                    <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="form.get('city_name').invalid && form.get('city_name').touched"
                    [flexFormControlError]="form.get('city_name')"></mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="full-width">
                <mat-label>{{ 'client.content.insee_code'|translate }}</mat-label>
                <input matInput [placeholder]="'client.content.insee_code'|translate" formControlName="insee_code">
                <button matSuffix mat-icon-button type="button" (click)="removeControlValue('insee_code')"
                    [disabled]="!form.get('insee_code').value">
                    <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="form.get('insee_code').invalid && form.get('insee_code').touched"
                    [flexFormControlError]="form.get('insee_code')" [customMessages]="{
                'string.max': 'form.validator.max_length'|translate: {max: 20}
              }"></mat-error>
            </mat-form-field>
        </div>

    </form>
</div>
